var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.01562V0H12V2.01562H6ZM17.4844 9C17.1406 8.03125 16.6562 7.17188 16.0312 6.42188L17.4375 4.96875C17.2188 4.71875 16.9844 4.48438 16.7344 4.26562C16.5156 4.01562 16.2812 3.78125 16.0312 3.5625L14.625 5.01562C13.8438 4.39062 12.9688 3.90625 12 3.5625C11.0625 3.1875 10.0625 3 9 3C7.75 3 6.57812 3.23438 5.48438 3.70312C4.42188 4.17188 3.46875 4.82812 2.625 5.67188C1.8125 6.48438 1.17188 7.4375 0.703125 8.53125C0.234375 9.625 0 10.7812 0 12C0 13.25 0.234375 14.4219 0.703125 15.5156C1.17188 16.6094 1.8125 17.5625 2.625 18.375C3.46875 19.1875 4.42188 19.8281 5.48438 20.2969C6.57812 20.7656 7.75 21 9 21C10.25 21 11.4062 20.7656 12.4688 20.2969C13.5625 19.8281 14.5156 19.1875 15.3281 18.375C16.1719 17.5625 16.8281 16.6094 17.2969 15.5156C17.7656 14.4219 18 13.25 18 12C18 10.9375 17.8281 9.9375 17.4844 9ZM12 8.01562H10.0078V16.0156H12V8.01562ZM6 8.01562V16.0156H7.99219V8.01562H6Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerPause);
export default __webpack_public_path__ + "static/media/timer_pause.aa18d35cc44567aec5281bc0a7a2f297.svg";
export { ForwardRef as ReactComponent };